import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const EDIT_COMMENT_CATEGORY = 'EDIT_COMMENT_CATEGORY';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/Comments/EditCommentCategory',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(EDIT_COMMENT_CATEGORY, service, mock);
